export interface Project {
  id: string
  address: string
  financeOption: 'cash' | 'african bank'
  financeStatus: 'pre-approved' | 'declined' | 'finance accepted'
  projectStatus: 'pending' | 'accepted' | 'scheduled' | 'commissioned'
}
export interface User {
  id: string
  name: string
  email: string
  mobile: string
  signupDate: Date
  projects: Project[]
}
export const mockUsers: User[] = [
  {
    id: '1',
    name: 'John Smith',
    email: 'john.smith@example.com',
    mobile: '+27 71 234 5678',
    signupDate: new Date('2023-02-15T09:30:00'),
    projects: [
      {
        id: '101',
        address: '123 Main Street, Cape Town',
        financeOption: 'cash',
        financeStatus: 'finance accepted',
        projectStatus: 'commissioned',
      },
      {
        id: '102',
        address: '45 Ocean View Drive, Durban',
        financeOption: 'african bank',
        financeStatus: 'pre-approved',
        projectStatus: 'pending',
      },
    ],
  },
  {
    id: '2',
    name: 'Sarah Johnson',
    email: 'sarah.j@example.com',
    mobile: '+27 82 345 6789',
    signupDate: new Date('2023-05-22T14:45:00'),
    projects: [
      {
        id: '201',
        address: '78 Mountain Road, Johannesburg',
        financeOption: 'african bank',
        financeStatus: 'declined',
        projectStatus: 'pending',
      },
    ],
  },
  {
    id: '3',
    name: 'David Nkosi',
    email: 'david.n@example.com',
    mobile: '+27 63 456 7890',
    signupDate: new Date('2022-11-08T11:20:00'),
    projects: [
      {
        id: '301',
        address: '15 Baobab Avenue, Pretoria',
        financeOption: 'cash',
        financeStatus: 'finance accepted',
        projectStatus: 'scheduled',
      },
      {
        id: '302',
        address: '92 Lion Street, Bloemfontein',
        financeOption: 'cash',
        financeStatus: 'finance accepted',
        projectStatus: 'accepted',
      },
      {
        id: '303',
        address: '7 Elephant Road, Port Elizabeth',
        financeOption: 'african bank',
        financeStatus: 'pre-approved',
        projectStatus: 'pending',
      },
    ],
  },
  {
    id: '4',
    name: 'Thandi Mbeki',
    email: 'thandi.m@example.com',
    mobile: '+27 84 567 8901',
    signupDate: new Date('2023-09-17T16:10:00'),
    projects: [],
  },
  {
    id: '5',
    name: 'Michael van der Merwe',
    email: 'michael.v@example.com',
    mobile: '+27 73 678 9012',
    signupDate: new Date('2023-01-05T08:15:00'),
    projects: [
      {
        id: '501',
        address: '33 Protea Complex, Stellenbosch',
        financeOption: 'african bank',
        financeStatus: 'finance accepted',
        projectStatus: 'commissioned',
      },
      {
        id: '502',
        address: '21 Vineyard Estate, Paarl',
        financeOption: 'cash',
        financeStatus: 'finance accepted',
        projectStatus: 'scheduled',
      },
    ],
  },
]
